import React, { useContext } from 'react';
import { Icons } from '@nextiva/next-ui-components';
import {
  actionTypes,
  LicensesContext,
} from 'containers/pages/BillingLicenses/licensesContext';
import {
  StyledBannerContainer,
  StyledBannerText,
  StyledPurchaseButton,
  StyledPurchaseButtonIcon,
  StyledPurchaseButtonText,
} from './PurchaseLicensesBanner.styles';

const BANNER_TEXT = 'Has your company grown? Purchase more licenses now.';
const BUTTON_TEXT = 'Purchase licenses';

interface IPurchaseLicenseBanner {
  toggleDrawer: () => void;
}

export const PurchaseLicensesBanner = ({
  toggleDrawer,
}: IPurchaseLicenseBanner) => {
  const {
    dispatch,
    licensesState: { editLicenseAssignment, pristine },
  } = useContext(LicensesContext);

  const onPurchaseButtonClick = (): void => {
    if (pristine) {
      dispatch({
        type: actionTypes.TOGGLE_PURCHASE_LICENSE_MODAL,
        license: editLicenseAssignment,
      });
      toggleDrawer();
    } else {
      dispatch({
        type: actionTypes.TOGGLE_SAVE_CHANGES_MODAL,
      });
    }
  };

  return (
    <StyledBannerContainer data-testid="PlatformAdminUI-PurchaseLicensesBanner">
      <StyledBannerText variant="body1">{BANNER_TEXT}</StyledBannerText>
      <StyledPurchaseButton
        color="primary"
        data-testid="PlatformAdminUI-PurchaseLicensesBanner-PurchaseButton"
        variant="contained"
        onClick={onPurchaseButtonClick}
      >
        <StyledPurchaseButtonIcon
          icon={Icons.upgrade}
          aria-label="Upgrade Icon"
        />
        <StyledPurchaseButtonText variant="button">
          {BUTTON_TEXT}
        </StyledPurchaseButtonText>
      </StyledPurchaseButton>
    </StyledBannerContainer>
  );
};
